module.exports = __webpack_public_path__ + "static/media/NewAppleWalletFullPhone-nz.08d6adfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/NewAppleWalletFullPhone-nz.png
// module id = 6123
// module chunks = 1